import {createFileRoute} from "@tanstack/react-router";
import {ProfileReferral} from "@/components/profile/referral/ProfileReferral";

export const Route = createFileRoute("/_mainLayout/profile/referral/")({
  component: ProfileReferral,
});
